import { render, staticRenderFns } from "./editNoticeViewList.vue?vue&type=template&id=56b680fe&scoped=true"
import script from "./editNoticeViewList.vue?vue&type=script&lang=js"
export * from "./editNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./editNoticeViewList.vue?vue&type=style&index=0&id=56b680fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b680fe",
  null
  
)

export default component.exports